import { html, LitElement } from 'lit';

class Icon404 extends LitElement {
  render() {
    return html`<svg
      width="334"
      height="334"
      viewBox="0 0 334 334"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 83.6667V150.333C17 154.754 18.7559 158.993 21.8816 162.118C25.0072 165.244 29.2464 167 33.6667 167H83.6667M83.6667 83.6667V250.333M133.667 133.667V233.667C133.667 238.087 135.423 242.326 138.548 245.452C141.674 248.577 145.913 250.333 150.333 250.333H183.667C188.087 250.333 192.326 248.577 195.452 245.452C198.577 242.326 200.333 238.087 200.333 233.667V200.333M200.333 133.667V100.333C200.333 95.9131 198.577 91.6738 195.452 88.5482C192.326 85.4226 188.087 83.6667 183.667 83.6667H150.333M250.333 83.6667V150.333C250.333 154.754 252.089 158.993 255.215 162.118C258.34 165.244 262.58 167 267 167H317M317 83.6667V250.333M17 17L317 317"
        stroke="#E88F2A"
        stroke-width="33.3333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg> `;
  }
}

customElements.define('icon-404', Icon404);
